module.exports = __webpack_public_path__ + "static/media/sms.ca7ff54b.png";